import React, { useState, useEffect } from "react";
import { supabase } from "../../supabaseClient.js";
import "../../styles/MasterFiling.css";

const DiamondTransactions = () => {
  const [workers, setWorkers] = useState([]);
  const [sizes, setSizes] = useState([]);
  const [colors, setColors] = useState([]);
  const [ledger, setLedger] = useState([]);

  const [selectedWorker, setSelectedWorker] = useState("");
  const [selectedSize, setSelectedSize] = useState("");
  const [selectedColor, setSelectedColor] = useState("");
  const [cts, setCts] = useState("");
  const [type, setType] = useState("ISSUE"); // default

  useEffect(() => {
    fetchWorkers();
    fetchDiamondOptions();
    fetchLedger();
  }, []);

  // LOAD WORKERS
  const fetchWorkers = async () => {
    const { data } = await supabase
      .from("WORKERS")
      .select("*")
      .eq("status", true);
    setWorkers(data || []);
  };

  // LOAD SIZE & COLOR FROM DIAMONDS TABLE
  const fetchDiamondOptions = async () => {
    const { data } = await supabase
      .from("DIAMONDS")
      .select("size, color")
      .eq("status", true);

    const uniqueSizes = [...new Set(data.map((d) => d.size))];
    const uniqueColors = [...new Set(data.map((d) => d.color))];

    setSizes(uniqueSizes);
    setColors(uniqueColors);
  };

  // LOAD LEDGER
  const fetchLedger = async () => {
    const { data } = await supabase
      .from("DIAMOND_TRANSACTIONS")
      .select("*, WORKERS(worker_name)")
      .order("created_at", { ascending: false });

    setLedger(data || []);
  };

  // SUBMIT ISSUE/RECEIVE
  const submitTransaction = async () => {
    if (!selectedWorker || !selectedSize || !selectedColor || !cts) {
      alert("Please fill all fields");
      return;
    }

    await supabase.from("DIAMOND_TRANSACTIONS").insert([
      {
        worker_id: selectedWorker,
        size: selectedSize,
        color: selectedColor,
        cts,
        type,
      },
    ]);

    setCts("");
    fetchLedger();
  };

  // TOTAL CALC
  const totalIssued = ledger
    .filter((l) => l.type === "ISSUE")
    .reduce((sum, r) => sum + Number(r.cts), 0);

  const totalReceived = ledger
    .filter((l) => l.type === "RECEIVE")
    .reduce((sum, r) => sum + Number(r.cts), 0);

  return (
    <div className="master-page">
      {/* INPUT CARD */}
      <div className="master-card">
        <h2 className="master-title">💎 Diamond Issue / Receive</h2>

        <label>Select Worker</label>
        <select
          value={selectedWorker}
          onChange={(e) => setSelectedWorker(e.target.value)}
        >
          <option value="">Select Worker</option>
          {workers.map((w) => (
            <option key={w.id} value={w.id}>
              {w.worker_name}
            </option>
          ))}
        </select>

        <label>Select Size</label>
        <select
          value={selectedSize}
          onChange={(e) => setSelectedSize(e.target.value)}
        >
          <option value="">Select Size</option>
          {sizes.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>

        <label>Select Color</label>
        <select
          value={selectedColor}
          onChange={(e) => setSelectedColor(e.target.value)}
        >
          <option value="">Select Color</option>
          {colors.map((c) => (
            <option key={c} value={c}>
              {c}
            </option>
          ))}
        </select>

        <label>CTS</label>
        <input
          type="number"
          value={cts}
          onChange={(e) => setCts(e.target.value)}
          placeholder="Enter CTS"
        />

        <label>Action</label>
        <div style={{ display: "flex", gap: "20px", margin: "10px 0" }}>
          <label>
            <input
              type="radio"
              checked={type === "ISSUE"}
              onChange={() => setType("ISSUE")}
            />{" "}
            Issue
          </label>
          <label>
            <input
              type="radio"
              checked={type === "RECEIVE"}
              onChange={() => setType("RECEIVE")}
            />{" "}
            Receive
          </label>
        </div>

        <button className="gold-btn" onClick={submitTransaction}>
          ✔ Submit
        </button>
      </div>


    </div>
  );
};

export default DiamondTransactions;
